import { render, staticRenderFns } from "./StudentsList.vue?vue&type=template&id=3c1bb5b3&"
import script from "./StudentsList.vue?vue&type=script&lang=js&"
export * from "./StudentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1bb5b3')) {
      api.createRecord('3c1bb5b3', component.options)
    } else {
      api.reload('3c1bb5b3', component.options)
    }
    module.hot.accept("./StudentsList.vue?vue&type=template&id=3c1bb5b3&", function () {
      api.rerender('3c1bb5b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Common/StudentsList.vue"
export default component.exports